// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import PrimaryErrorMessage from './PrimaryErrorMessage';
import { useTranslator } from '../../../components/i18n/useTranslator';

// Constants
import {
    SERVICE_STATUS_URL,
    HELP_CENTER_RESTRICTED_COUNTRY_TROUBLESHOOTING,
} from '../../../../common/utils/urlConstants';
import { RESPONSE_ERROR } from '../../../../common/error/errorConstants';
import { ERROR_LOCALE_KEYS } from '../../../../common/error/errorLocaleKeys';

const AuthErrorMessage = (props) => {
    const { primaryError, hide } = props;
    const translate = useTranslator('errors');

    const getErrorContent = (error) => {
        // Handle special error types that need custom UI with links
        if (error?.isNetworkError) {
            // Use translated message with React components for links
            return translate(ERROR_LOCALE_KEYS.NETWORK.CONNECTION_LOST, undefined, {
                components: {
                    statusLink: <a href={SERVICE_STATUS_URL} target="_blank" rel="noopener noreferrer" />,
                },
            });
        }

        if (!error?.message || error.status === 500) {
            // Use translated generic server error with link
            return translate(ERROR_LOCALE_KEYS.SERVER.GENERIC, undefined, {
                components: {
                    statusLink: <a href={SERVICE_STATUS_URL} target="_blank" rel="noopener noreferrer" />,
                },
            });
        }

        if (error?.code === RESPONSE_ERROR.EMBARGOED_IP) {
            // Use translated embargoed IP error with link
            return translate(ERROR_LOCALE_KEYS.AUTH.EMBARGOED_IP, undefined, {
                components: {
                    helpLink: (
                        <a
                            href={HELP_CENTER_RESTRICTED_COUNTRY_TROUBLESHOOTING}
                            target="_blank"
                            rel="noopener noreferrer"
                        />
                    ),
                },
            });
        }

        // If error has errorLocaleKey, use it for translation
        if (error?.errorLocaleKey) {
            return translate(error.errorLocaleKey, error.context);
        }

        // Fallback to original message
        return error?.message || 'Sorry, something went wrong. Please try again.';
    };

    const errorContent = primaryError ? getErrorContent(primaryError) : null;

    if (!errorContent || hide) return null;

    return <PrimaryErrorMessage message={errorContent} />;
};

AuthErrorMessage.propTypes = {
    primaryError: PropTypes.object,
    hide: PropTypes.bool,
};

export default AuthErrorMessage;
